import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setUserProfile } from '../../../redux/actions/authActions';
import { Modal } from 'reactstrap';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CloseIcon from 'mdi-react/CloseIcon';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import AlertCircleIcon from 'mdi-react/AlertCircleOutlineIcon';
import CreditCardIcon from 'mdi-react/CreditCardIcon';
import ContactPhoneIcon from 'mdi-react/ContactPhoneIcon';
import PremiumCreditIcon from 'mdi-react/PlusCircleMultipleOutlineIcon';
import EmailIcon from 'mdi-react/EmailOutlineIcon';
import FileIcon from 'mdi-react/FileDocumentOutlineIcon';
import AccountGroupIcon from 'mdi-react/AccountGroupIcon';
import DownloadIcon from 'mdi-react/DownloadIcon';
import PlayIcon from 'mdi-react/PlayCircleOutlineIcon';
import { _axiosCall } from '../../helpers/apicalls';
import { _formatNumber } from '../../helpers/utils';
import AutoRechargeSettings from '../premium_credits/AutoRechargeSettings';
import StripeCardSetupModal from '../payment/stripe/StripeCardSetupModal';
import { premiumCreditPacks } from '../premium_credits/PremiumCreditsPurchaseModal';

var apiUrl = process.env.API_ROOT;

function _getThemeClass() {
  if (document.querySelector('.role-bhs-agent')) return 'role-bhs-agent';
  if (document.querySelector('.role-elliman-agent')) return 'role-elliman-agent';
  return '';
}

var STRIPE_PREMIUM_CREDITS_PRODUCT_ID =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local'
    ? 'prod_TzWUHN69NLB7WH'
    : 'prod_TzWWtocat4f6kG';

var STRIPE_TAX_RATE_ID =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local'
    ? 'txr_1HPuUwG44QC64PsRi91xssbx'
    : 'txr_1HCVNJG44QC64PsRdrtshCba';

var MAX_BULK_SKIP_TRACE_RECORDS = 1000;

function _getUserPremiumCredits(user) {
  if (!user) return 0;
  if (typeof user.premiumCredits === 'number') return user.premiumCredits;
  if (user.profile && typeof user.profile.premiumCredits === 'number') return user.profile.premiumCredits;
  return 0;
}

function _estimateCreditRange(recordCount) {
  var est = recordCount;
  var low = Math.round(est * 0.75);
  // High end accounts for owner fan-out (up to 3 people per parsed owner) and
  // LLC unmasking via ACRIS signatories — both produce extra contact rows.
  var high = Math.round(est * 1.75);
  return { low: low, est: est, high: high };
}

function _getOptimalPack(creditsNeeded) {
  // Find the smallest pack that covers the need in 1-2 recharges
  for (var i = 0; i < premiumCreditPacks.length; i++) {
    var pack = premiumCreditPacks[i];
    if (pack.credits >= creditsNeeded) return pack;
    if (pack.credits * 2 >= creditsNeeded) return pack;
  }
  return premiumCreditPacks[premiumCreditPacks.length - 1];
}

class BulkSkipTraceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 'overview',
      loading: false,
      paymentMethod: null,
      hasCard: null,
      checkingCard: false,
      showPaymentModal: false,
      setupClientSecret: null,
      jobId: null,
      jobStatus: null,
      pollInterval: null,
      testMode: props.user && props.user.role && props.user.role.indexOf('admin') >= 0,
      error: null
    };
  }

  componentDidMount() {
    this._checkCard();
  }

  componentWillUnmount() {
    if (this.state.pollInterval) {
      clearInterval(this.state.pollInterval);
    }
    // If a job was started, refresh user profile to sync credits
    if (this.state.jobId) {
      this._refreshUserCredits();
    }
  }

  _refreshUserCredits = () => {
    var _this = this;
    var { user } = this.props;
    _axiosCall({
      url: apiUrl + '/buyerslist/userdata/' + (user.id || user.user_id || user.sub),
      method: 'get'
    })
      .then(function (res) {
        if (res && res.length > 0 && typeof res[0].premiumCredits === 'number') {
          var updatedUser = Object.assign({}, _this.props.user, { premiumCredits: res[0].premiumCredits });
          _this.props.setUserProfile(updatedUser);
        }
      })
      .catch(function () {});
  };

  _checkCard = () => {
    var _this = this;
    var { user } = this.props;

    if (!user.customerId) {
      this.setState({ hasCard: false, checkingCard: false });
      return;
    }

    this.setState({ checkingCard: true });

    _axiosCall({
      url: apiUrl + '/buyerslist/stripe/get-payment-methods',
      method: 'post',
      query: { customer_id: user.customerId }
    })
      .then(function (res) {
        if (res && res.success && res.methods && res.methods.length > 0) {
          _this.setState({ hasCard: true, paymentMethod: res.methods[0], checkingCard: false });
        } else {
          _this.setState({ hasCard: false, checkingCard: false });
        }
      })
      .catch(function () {
        _this.setState({ hasCard: false, checkingCard: false });
      });
  };

  _createSetupIntent = () => {
    var _this = this;
    var { user } = this.props;

    function _doSetupIntent(customerId) {
      _axiosCall({
        url: apiUrl + '/buyerslist/stripe/create-setup-intent',
        method: 'post',
        query: { customer_id: customerId }
      })
        .then(function (res) {
          if (res && res.client_secret) {
            _this.setState({ setupClientSecret: res.client_secret, showPaymentModal: true });
          }
        })
        .catch(function (err) {
          console.error('Failed to create setup intent', err);
        });
    }

    if (user.customerId) {
      _doSetupIntent(user.customerId);
    } else {
      // Create Stripe customer first
      _axiosCall({
        url: apiUrl + '/buyerslist/stripe/create-basic-customer',
        method: 'post',
        query: {
          userId: user.id || user.sub,
          name: (user.firstName && user.lastName) ? user.firstName + ' ' + user.lastName : '',
          email: user.email
        }
      })
        .then(function (res) {
          if (res && res.customerId) {
            _this.props.setUserProfile(Object.assign({}, user, { customerId: res.customerId }));
            _doSetupIntent(res.customerId);
          }
        })
        .catch(function (err) {
          console.error('Failed to create Stripe customer', err);
        });
    }
  };

  _startJob = () => {
    var _this = this;
    var { user, coreName, queryOptions, buildingName } = this.props;
    var { testMode } = this.state;
    var autoRecharge = (user && user.autoRecharge) || {};
    var exportName = buildingName ? 'Contact Info - ' + buildingName : 'Contact Info Export';

    var autoRechargePayload = { enabled: false };
    if (autoRecharge.enabled && autoRecharge.pack_id) {
      var pack = premiumCreditPacks.find(function (p) { return p.id === autoRecharge.pack_id; });
      if (pack) {
        autoRechargePayload = {
          enabled: true,
          pack_id: autoRecharge.pack_id,
          threshold: autoRecharge.threshold || 10,
          creditConfig: {
            id: pack.id,
            label: pack.label,
            credits: pack.credits,
            pricePerCredit: pack.pricePerCredit,
            stripeProductId: STRIPE_PREMIUM_CREDITS_PRODUCT_ID,
            taxCode: STRIPE_TAX_RATE_ID
          }
        };
      }
    }

    this.setState({ loading: true, step: 'processing', error: null });

    _axiosCall({
      url: apiUrl + '/dataexport/batch-skiptrace-v2',
      method: 'post',
      query: {
        core_name: coreName || 'we3-properties',
        user: user,
        export_name: exportName,
        options: Object.assign({}, queryOptions, { rows: MAX_BULK_SKIP_TRACE_RECORDS }),
        auto_recharge: autoRechargePayload,
        generate_csv: true,
        save_to_my_owners: false,
        test_mode: testMode
      }
    })
      .then(function (res) {
        if (res && res.success && res.job_id) {
          _this.setState({ loading: false, jobId: res.job_id });
          _this._startPolling(res.job_id);
        } else {
          var msg = (res && (res.message || res.error)) || 'Failed to start job';
          console.error('Bulk skip trace failed response:', res);
          _this.setState({ loading: false, error: typeof msg === 'string' ? msg : 'Failed to start job' });
        }
      })
      .catch(function (err) {
        console.error('Failed to start bulk skip trace', err);
        _this.setState({ loading: false, error: 'Unable to connect to server. Please try again.' });
      });
  };

  _startPolling = (jobId) => {
    var _this = this;
    var interval = setInterval(function () {
      _axiosCall({
        url: apiUrl + '/dataexport/batch-skiptrace-v2/status',
        method: 'post',
        query: { job_id: jobId }
      })
        .then(function (res) {
          if (res && res.success && res.job) {
            _this.setState({ jobStatus: res.job });
            if (res.job.status === 'completed' || res.job.status === 'partial' || res.job.status === 'failed') {
              clearInterval(_this.state.pollInterval);
              _this.setState({ pollInterval: null });
              // Refresh user's premium credits in Redux
              if (res.job.credits_used > 0) {
                var updatedUser = Object.assign({}, _this.props.user);
                var currentCredits = _getUserPremiumCredits(updatedUser);
                updatedUser.premiumCredits = Math.max(0, currentCredits - res.job.credits_used);
                _this.props.setUserProfile(updatedUser);
              }
            }
          }
        })
        .catch(function () {});
    }, 5000);
    this.setState({ pollInterval: interval });
  };

  _renderOverview() {
    var { user, totalCount } = this.props;
    var { hasCard, checkingCard, paymentMethod, testMode } = this.state;
    var premiumCredits = _getUserPremiumCredits(user);
    var autoRecharge = (user && user.autoRecharge) || {};
    var recordCount = Math.min(totalCount || 0, MAX_BULK_SKIP_TRACE_RECORDS);
    var isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local';
    var needsAutoRecharge = premiumCredits <= 0 && !autoRecharge.enabled;
    var canStart = hasCard && recordCount > 0 && !needsAutoRecharge;
    var range = _estimateCreditRange(recordCount);
    var creditsShort = Math.max(0, range.high - premiumCredits);
    var optimalPack = creditsShort > 0 ? _getOptimalPack(creditsShort) : null;

    return (
      <div className="premium-dashboard">
        <div className="premium-grid3" style={{ gap: 20, padding: 24 }}>

          {/* Left column — what you get */}
          <div className="premium-benefits" style={{ flex: '1 1 300px', minWidth: 280 }}>
            <div className="premium-benefits__badge">Bulk Contact Export</div>
            <div className="premium-benefits__title" style={{ fontSize: 24, marginTop: 4 }}>
              Find owner emails & phones
            </div>

            <ul className="premium-benefits__list" style={{ margin: '16px 0' }}>
              <li>
                <span className="premium-check">&#10003;</span>
                Skip trace each owner to find contact info
              </li>
              <li>
                <span className="premium-check">&#10003;</span>
                Unmasks LLC owners via ACRIS signatories
              </li>
              <li>
                <span className="premium-check">&#10003;</span>
                Only charged if email or phone is found
              </li>
              <li>
                <span className="premium-check">&#10003;</span>
                Results saved in Downloads for future use
              </li>
              <li>
                <span className="premium-check">&#10003;</span>
                CSV format compatible for easy data exchange
              </li>
              <li>
                <span className="premium-check">&#10003;</span>
                Runs in background, you get an email when done
              </li>
            </ul>

            {premiumCredits < recordCount && !autoRecharge.enabled && !needsAutoRecharge && (
              <div style={{ marginTop: 16, padding: '10px 14px', background: '#FFF5F5', borderRadius: 8, border: '1px solid #FED7D7', fontSize: 13, color: '#d32f2f' }}>
                <AlertCircleIcon size={14} style={{ marginRight: 4, marginTop: -2 }} />
                Balance may not cover all records. Set up auto-recharge below.
              </div>
            )}
          </div>

          {/* Right column — summary + settings card */}
          <div style={{ flex: '1 1 380px', minWidth: 340, display: 'flex', flexDirection: 'column', gap: 16 }}>

            {/* Estimated cost — elevated */}
            <div className="bulk-skiptrace-cost-highlight" style={{ padding: '16px 20px', background: '#FAF5FF', border: '2px solid #780F9E', borderRadius: 12, boxShadow: '0 2px 6px rgba(120, 15, 158, 0.12)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div className="bulk-skiptrace-cost-highlight__label" style={{ fontSize: 15, fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: 0.4 }}>Estimated Cost</div>
                  <div className="bulk-skiptrace-cost-highlight__sub" style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                    {optimalPack ? 'Based on optimal ' + optimalPack.label + ' pack at $' + optimalPack.pricePerCredit.toFixed(2) + '/credit' : '1 premium credit per owner contact found'}
                  </div>
                </div>
                <div className="bulk-skiptrace-cost-highlight__amount" style={{ fontSize: 17, fontWeight: 700, color: '#780F9E', whiteSpace: 'nowrap', marginLeft: 16 }}>
                  ${(range.low * (optimalPack ? optimalPack.pricePerCredit : 0.80)).toFixed(2)} – ${(range.high * (optimalPack ? optimalPack.pricePerCredit : 0.80)).toFixed(2)}
                </div>
              </div>
            </div>

            {/* Records card */}
            <div className="skiptrace-profile-card" style={{ marginBottom: 0 }}>
              <div className="skiptrace-section-title" style={{ marginBottom: 12 }}>
                <AccountGroupIcon size={20} /> <span>Export Details</span>
              </div>
              <div className="skiptrace-profile-divider" />
              <div style={{ padding: '8px 0' }}>
                {[
                  { label: 'Properties to process', sub: 'Total units in your current search', value: _formatNumber(recordCount) + (totalCount > MAX_BULK_SKIP_TRACE_RECORDS ? ' (max)' : '') },
                  { label: 'Estimated premium credits needed', sub: 'Some properties have multiple owners, some may not have contact info', value: _formatNumber(range.low) + ' – ' + _formatNumber(range.high) },
                  { label: 'Your premium credit balance', sub: 'Premium credits available before auto-recharge', value: _formatNumber(premiumCredits) + ' premium credits' }
                ].map(function (row, i) {
                  return (
                    <div key={i} className="skiptrace-line-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, alignItems: 'flex-start' }}>
                      <span style={{ color: '#4b5563', fontSize: 14 }}>
                        {row.label}
                        <br /><span style={{ fontSize: 11, color: '#9ca3af' }}>{row.sub}</span>
                      </span>
                      <strong style={{ color: '#111827', whiteSpace: 'nowrap', marginLeft: 12 }}>{row.value}</strong>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Card on file — only show if no card, before auto-recharge */}
            {hasCard === false && (
              <div className="skiptrace-profile-card" style={{ marginBottom: 0, border: '1px solid #FED7D7', background: '#FFF5F5' }}>
                <div className="skiptrace-section-title" style={{ marginBottom: 8 }}>
                  <CreditCardIcon size={20} style={{ color: '#d32f2f' }} /> <span style={{ color: '#d32f2f' }}>Payment Method Required</span>
                </div>
                <div className="skiptrace-profile-divider" />
                <div style={{ padding: '10px 0' }}>
                  <div style={{ fontSize: 13, color: '#374151', marginBottom: 4 }}>A credit card is needed to purchase premium credits for skip tracing. You are only charged when contact info is found for an owner.</div>
                  <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 12 }}>Your card will be used for auto-recharge during the export.</div>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={this._createSetupIntent}
                    style={{ background: '#780F9E', color: '#fff', textTransform: 'none', fontWeight: 600, borderRadius: 8 }}
                  >
                    <CreditCardIcon size={14} style={{ marginRight: 6 }} /> Add Card
                  </Button>
                </div>
              </div>
            )}

            {/* Auto-recharge — only show once a card is on file */}
            {hasCard === true && (
              <div className="skiptrace-profile-card" style={{ marginBottom: 0 }}>
                <AutoRechargeSettings compact={false} onSave={function () {}} autoEnable={premiumCredits <= 0} />
                {optimalPack && creditsShort > 0 && (
                  <div style={{ marginTop: 10, padding: '10px 14px', background: '#F5F0FF', borderRadius: 8, border: '1px solid #D6BAE8', fontSize: 13, color: '#4b5563' }}>
                    <strong style={{ color: '#780F9E' }}>Recommended:</strong> {optimalPack.label} pack ({_formatNumber(optimalPack.credits)} premium credits at ${optimalPack.pricePerCredit.toFixed(2)}/credit = ${(optimalPack.credits * optimalPack.pricePerCredit).toFixed(2)}) to cover this export.
                  </div>
                )}
              </div>
            )}

            {/* Test mode (admin only) */}
            {isDev && user && user.role && user.role.indexOf('admin') >= 0 && (
              <div style={{ padding: '8px 14px', background: '#FFF5F5', borderRadius: 10, border: '1px solid #FED7D7' }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={testMode}
                      onChange={function (e) { this.setState({ testMode: e.target.checked }); }.bind(this)}
                      color="secondary"
                      size="small"
                    />
                  }
                  label={<span style={{ fontSize: 13, color: '#d32f2f', fontWeight: 600 }}>Test Mode — dummy data, premium credits still deducted</span>}
                />
              </div>
            )}

          </div>
        </div>

        {/* Footer action */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 24px', borderTop: '1px solid #e5e7eb' }}>
          <Button
            variant="outlined"
            onClick={this.props.onClose}
            style={{ borderColor: '#780F9E', color: '#780F9E', textTransform: 'none', marginRight: 12 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={this._startJob}
            disabled={!canStart}
            style={{
              background: canStart ? '#780F9E' : '#DBE0E8',
              color: '#fff',
              textTransform: 'uppercase'
            }}
          >
            <ContactPhoneIcon size={18} style={{ marginRight: 8 }} />
            Start Export ({_formatNumber(recordCount)} properties)
          </Button>
        </div>
      </div>
    );
  }

  _renderProcessing() {
    var { jobStatus, loading, error } = this.state;

    if (loading) {
      return (
        <div style={{ padding: 60, textAlign: 'center' }}>
          <LinearProgress style={{ borderRadius: 4, marginBottom: 20 }} />
          <div style={{ fontSize: 16, color: '#111827', fontWeight: 600 }}>Submitting your export...</div>
          <div style={{ fontSize: 14, color: '#6b7280', marginTop: 6 }}>This will only take a moment.</div>
        </div>
      );
    }

    if (error) {
      return (
        <div style={{ padding: 60, textAlign: 'center' }}>
          <AlertCircleIcon size={48} style={{ color: '#d32f2f', marginBottom: 16 }} />
          <div style={{ fontSize: 16, color: '#d32f2f', fontWeight: 600, marginBottom: 6 }}>{error}</div>
          <div style={{ fontSize: 14, color: '#6b7280', marginBottom: 20 }}>Please try again. If the issue persists, contact support.</div>
          <Button
            variant="outlined"
            onClick={function () { this.setState({ step: 'overview', error: null }); }.bind(this)}
            style={{ borderColor: '#780F9E', color: '#780F9E', textTransform: 'uppercase', fontWeight: 600, borderRadius: 10 }}
          >
            Back to Settings
          </Button>
        </div>
      );
    }

    var processed = jobStatus ? jobStatus.processed : 0;
    var total = jobStatus ? jobStatus.total_records : 0;
    var creditsUsed = jobStatus ? jobStatus.credits_used : 0;
    var ownersFound = jobStatus ? (jobStatus.owners_found || creditsUsed) : 0;
    var status = jobStatus ? jobStatus.status : 'processing';
    var progress = total > 0 ? Math.round((processed / total) * 100) : 0;
    var isDone = status === 'completed' || status === 'partial' || status === 'failed';

    return (
      <div style={{ padding: 30 }}>
        {/* Status banner */}
        <div className="skiptrace-background-action" style={{ marginBottom: 24, border: isDone ? '1px solid #D6BAE8' : '1px solid #BF96D9', textAlign: 'left' }}>
          {isDone ? (
            <CheckCircleIcon size={28} style={{ color: '#9600BF', flexShrink: 0 }} />
          ) : (
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid #BF96D9', borderTopColor: '#9600BF', animation: 'spin 1s linear infinite', flexShrink: 0 }} />
          )}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#111827' }}>
              {status === 'completed' ? 'Export Complete' : status === 'partial' ? 'Export Partially Complete' : status === 'failed' ? 'Export Failed' : 'Export Running in Background'}
            </div>
            <div style={{ fontSize: 14, color: '#4b5563', marginTop: 2 }}>
              {isDone
                ? 'Your results are ready. Check your email for the CSV download.'
                : 'You can close this window and continue working. We\'ll email you when it\'s done.'}
            </div>
          </div>
        </div>

        {/* Progress bar */}
        {total > 0 && (
          <div style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <span style={{ fontSize: 13, color: '#6b7280' }}>Progress</span>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#780F9E' }}>{progress}%</span>
            </div>
            <LinearProgress
              variant="determinate"
              value={progress}
              style={{ height: 8, borderRadius: 4, background: '#e5e7eb' }}
              classes={{ bar: 'bulk-skiptrace-progress-bar' }}
            />
          </div>
        )}

        {/* Stats */}
        <div className="skiptrace-profile-card">
          {[
            { icon: <FileIcon size={16} style={{ color: '#6b7280' }} />, label: 'Properties processed', value: _formatNumber(processed) + (total ? ' / ' + _formatNumber(total) : '') },
            { icon: <ContactPhoneIcon size={16} style={{ color: '#6b7280' }} />, label: 'Owners with contact info', value: _formatNumber(ownersFound) },
            { icon: <PremiumCreditIcon size={16} style={{ color: '#6b7280' }} />, label: 'Premium credits used', value: _formatNumber(creditsUsed) }
          ].map(function (row, i) {
            return (
              <div key={i} className="skiptrace-line-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 14 }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#6b7280' }}>{row.icon} {row.label}</span>
                <strong style={{ color: '#111827' }}>{row.value}</strong>
              </div>
            );
          })}
        </div>

        {/* Where to find results */}
        {isDone && (
          <div style={{ marginTop: 16 }}>
            <div className="skiptrace-section-title" style={{ marginBottom: 10 }}>
              <CheckCircleIcon size={18} style={{ color: '#9600BF' }} /> <span>Your results</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', background: '#F5F7FA', borderRadius: 8, fontSize: 14, color: '#374151' }}>
              <DownloadIcon size={18} style={{ color: '#780F9E', flexShrink: 0 }} />
              <span>See your CSV report under <a href="/my-exports" style={{ color: '#780F9E', fontWeight: 600 }}>Downloads</a></span>
            </div>
          </div>
        )}

        {status === 'partial' && (
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '12px 16px', background: '#FFF5F5', borderRadius: 10, border: '1px solid #FED7D7', marginTop: 16 }}>
            <AlertCircleIcon size={18} style={{ color: '#d32f2f', marginTop: 1, flexShrink: 0 }} />
            <span style={{ fontSize: 13, color: '#d32f2f' }}>Processing stopped early. Premium credits may have been exhausted or auto-recharge failed. Check your payment method and premium credit balance.</span>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
          <Button
            variant="contained"
            onClick={this.props.onClose}
            style={{ background: '#780F9E', color: '#fff', textTransform: 'uppercase' }}
          >
            {isDone ? <CheckCircleIcon size={16} style={{ marginRight: 6 }} /> : <PlayIcon size={16} style={{ marginRight: 6 }} />}
            {isDone ? 'Done' : 'Close & Run in Background'}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    var { isOpen, onClose, user } = this.props;
    var { step, showPaymentModal, setupClientSecret } = this.state;

    return (
      <Fragment>
        <Modal isOpen={isOpen} toggle={onClose} className={'modal-dialog--primary modal-dialog--header ' + _getThemeClass()} scrollable style={{ minWidth: 1080 }} contentClassName="bulk-skiptrace-modal-content">
          <div className="modal__header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h4 className="bold-text modal__title" style={{ margin: 0 }}>
              <ContactPhoneIcon size={22} style={{ marginRight: 8, marginTop: -2 }} />
              Export Contact Info
            </h4>
            <button className="lnr lnr-cross modal__close-btn" style={{ position: 'static' }} onClick={onClose} />
          </div>
          <div className="modal__body" style={{ padding: 0, textAlign: 'left' }}>
            {step === 'overview' && this._renderOverview()}
            {step === 'processing' && this._renderProcessing()}
          </div>
        </Modal>

        {showPaymentModal && setupClientSecret && (
          <StripeCardSetupModal
            isOpen={showPaymentModal}
            clientSecret={setupClientSecret}
            user={{ name: (user.firstName || '') + ' ' + (user.lastName || ''), email: user.email }}
            onClose={function () { this.setState({ showPaymentModal: false }); }.bind(this)}
            onComplete={function () {
              this.setState({ showPaymentModal: false });
              this._checkCard();
            }.bind(this)}
          />
        )}

        <style dangerouslySetInnerHTML={{ __html: '@keyframes spin { to { transform: rotate(360deg); } } .bulk-skiptrace-modal-content { text-align: left !important; padding: 0 !important; } .bulk-skiptrace-progress-bar { background-color: #780F9E !important; }' }} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setUserProfile: setUserProfile }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkSkipTraceModal);
